import { useMediaQuery } from "@mui/material";
import { BudgetSummary, BudgetManagerSummary } from "./types";

interface SummaryCardsProps {
  summary: BudgetSummary | BudgetManagerSummary;
  loading?: boolean;
  persona?: string;
}

const SummaryCards = ({ summary, loading = false, persona }: SummaryCardsProps) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 1024px) and (min-width: 769px)");
  const isManager = persona === "MANAGER";

  const getBorderColor = (key: string): string => {
    switch (key) {
      case "enviados":
        return "#6B7280";
      case "alterados":
      case "contraproposta":
        return "#F97316";
      case "aceito":
      case "concluido":
        return "#10B981";
      case "recusado":
        return "#EF4444";
      default:
        return "#6B7280";
    }
  };

  const cards = isManager
    ? [
        { key: "enviados", label: "Enviados para análise" },
        { key: "contraproposta", label: "Contra proposta" },
        { key: "aceito", label: "Aprovados pelo gestor" },
        { key: "recusado", label: "Recusados pelo gestor" },
      ]
    : [
        { key: "enviados", label: "Enviados para análise" },
        { key: "alterados", label: "Alterados" },
        { key: "contraproposta", label: "Contraproposta" },
        { key: "aceito", label: "Aprovados pelo Volks|total" },
        { key: "recusado", label: "Recusado" },
        { key: "concluido", label: "Aprovados pelo cliente" },
      ];

  return (
    <div className={`${isMobile ? "mb-4" : "margin-bottom-20"}`}>
      <div className={`flex ${isMobile ? "flex-col gap-3" : isTablet ? "flex-row flex-wrap gap-4" : "flex-row gap-4"} items-stretch w-full`}>
        {cards.map((card) => (
          <div
            key={card.key}
            className={`bg-white rounded-lg shadow-sm border-l-4 ${isMobile ? "w-full p-4 min-h-[100px]" : isTablet ? "flex-1 min-w-[calc(50%-8px)] p-4" : "flex-1 p-5"} flex flex-col justify-start items-start`}
            style={{
              borderLeftColor: getBorderColor(card.key),
              borderLeftWidth: isMobile ? "6px" : "4px",
            }}
          >
            <div className="w-full flex flex-col gap-2">
              <div className={`${isMobile ? "text-size-11" : "text-size-14"} font-normal text-gray-600 text-left leading-tight`}>
                {card.label}
              </div>
              <div className={`${isMobile ? "text-[42px] pt-4" : isTablet ? "text-[32px]" : "text-[36px]"} font-bold text-gray-900 text-left leading-none font-sans`}>
                {loading ? "-" : (summary as any)[card.key] ?? 0}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryCards;
